import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

import { BrandProvider } from "./context/BrandContext";
import AnimatedRoutes from "./routes/AnimatedRoutes";
import { CartProvider } from "./context/CartContext";

function App() {
  return (
    <Router>
      <BrandProvider>
        <CartProvider>
          <AnimatedRoutes />
        </CartProvider>
      </BrandProvider>
    </Router>
  );
}

export default App;
